import React, { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOrgDetails, setToast, setUser } from "./redux/userSlice";
import { errorMsgWork, getCookie } from "./utils/utilFunction";
import { orgInfoApi, userInfo } from "./services/api.service";
import RouterElement from "./routes";
import { ThemeContext } from "./Context/ThemeProvider";

const AppLayout = () => {
  const dispatch = useDispatch();
  const { setTheme } = useContext(ThemeContext);
  const token = getCookie("persistent_auth");
  const { orgDetails } = useSelector((state) => state.user);

  useEffect(() => {
    if (orgDetails?.name) document.title = orgDetails?.name;
  }, [orgDetails]);

  useEffect(() => {
    if (token) {
      getUserData();
    } else {
      getOrgInfo();
    }
  }, []);

  const getUserData = async () => {
    try {
      const userData = await userInfo();
      dispatch(setUser({ ...userData?.data }));
      dispatch(setOrgDetails(userData?.data?.organization));
      updateTheme(userData?.data?.organization);
    } catch ({ response }) {
      dispatch(setToast({ msg: errorMsgWork(response) }));
    }
  };

  const getOrgInfo = async () => {
    try {
      const res = await orgInfoApi();
      dispatch(setOrgDetails(res?.data));
      updateTheme(res?.data);
    } catch (error) {
      console.error("Error fetching org info:", error);
    }
  };

  const updateTheme = (data) => {
    const themeData = {
      navbar: data?.navbar,
      "navbar-text": data?.navbar_text,
      primary: data?.primary_btn,
      "primary-disable": `${data?.primary_btn}90`,
      "primary-link": data?.primary_link,
      "primary-background": data?.background,
      secondary: data?.secondary,
      org_primary: data?.org_primary,
    };
    setTheme(themeData);
  };

  return <RouterElement />;
};

export default AppLayout;
